import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes"];
import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { default as withStyles } from '../styles';
import { default as MuiExpansionPanelActions } from '@material-ui/core/AccordionActions';
import ExpansionPanelContext from './internal/ExpansionPanelContext';
import { spacingVariant } from './../globalSpacing';
import { spacing40, spacing50 } from '../styles/tokens';

var styles = function styles(theme) {
  var _root;

  return {
    root: (_root = {
      padding: spacing40 + " " + spacing40 + " " + spacing40
    }, _root[theme.breakpoints.up('lg')] = {
      padding: spacing50 + " " + spacing50 + " " + spacing50
    }, _root),
    none: {
      padding: 0
    }
  };
};
/**
 * A component that....
 */


var ExpansionPanelActions = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var _useContext = useContext(ExpansionPanelContext),
      spacing = _useContext.spacingOptions.spacing;

  var classes = props.classes,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classOverrides = {
    root: classNames(classes.root, (_classNames = {}, _classNames[classes.none] = spacing === spacingVariant.NONE, _classNames))
  };
  return /*#__PURE__*/React.createElement(MuiExpansionPanelActions, _extends({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});
ExpansionPanelActions.muiName = 'ExpansionPanelActions';
ExpansionPanelActions.displayName = 'ExpansionPanelActions';
ExpansionPanelActions.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
}; // If default props are needed, they must be set here
// ExpansionPanelActions.defaultProps = { };

export default withStyles(styles)(ExpansionPanelActions);